import { render, staticRenderFns } from "./DeviceFieldCard.vue?vue&type=template&id=1cfa0bfc&scoped=true&"
import script from "./DeviceFieldCard.vue?vue&type=script&lang=js&"
export * from "./DeviceFieldCard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceFieldCard.vue?vue&type=style&index=0&id=1cfa0bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfa0bfc",
  null
  
)

export default component.exports